import Draggable from "react-draggable";
import { useRef } from "react";
import { FaCheck, FaTimes } from 'react-icons/fa'
import { errorColor, goodColor, primary45 } from "../utils/colors";

export default function DraggableSignature({ url, onEnd, onSet, onCancel }) {
  const dragRef = useRef(null);
  const styles = {
    container: {
      position: 'absolute',
      zIndex: 100000,
      border: `2px solid ${primary45}`,
    },
    controls: {
      position: 'absolute',
      right: 0,
      display: 'inline-block',
      backgroundColor: primary45,
      // borderRadius: 4,
    },
    smallButton: {
      display: 'inline-block',
      cursor: 'pointer',
      padding: 4,
    }
  }
  return (
    <div className="dragableSignature">
      <Draggable onStop={() => onEnd({ rect: dragRef.current?.getBoundingClientRect?.() })}>
        <div ref={dragRef} style={styles.container}>
          <div style={styles.controls}>
            <div style={styles.smallButton} onClick={onSet}><FaCheck color={goodColor} /></div>
            <div style={styles.smallButton} onClick={onCancel}><FaTimes color={errorColor} /></div>
          </div>
          <img src={url} style={styles.img} draggable={false} />
        </div>
      </Draggable>
    </div>
  );
}
